import React, { Suspense, useState } from 'react';
import { BrowserRouter } from 'react-router-dom'
import axios, { Axios } from 'axios'
import './App.css'
import './index.css'
import { Provider } from "react-redux"
import store from '../../../store'
import '../../../utilitie/setUpYupMethods'

import ScreenProvider from '../../../contexts/ScreenProvider'
import ThemeProvider from '@mui/system/ThemeProvider'
import CssBaseline from '@mui/material/CssBaseline'

import mainTheme from '../../../theme/mainTheme'
import LoadingFullScreen from '../../../components/global/Loading/LoadingFullScreen'

import { setupInterceptorsTo } from '../../../service/axios'
import RenderRoute from '../../../routes'
import { QueryClient, QueryClientProvider } from 'react-query'
import SnackBarProviderConfig from '../Snack/SnackBarProviderConfig'
import metaEnv from '../../../helper/metaEnv'
import GetUserInfo from '../../../routes/RequreAuth/GetUserInfo'
import { ReactQueryDevtools } from 'react-query/devtools'
import EnvironmentBadge from '../../global/Widget/EnvironmentBadge'
import AdminSessionExpiredDialog from '../../global/Auth/AdminSessionExpiredDialog'

import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import dayjs from 'dayjs'

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.tz.setDefault("Asia/Bangkok")

export const farmbookAxios = axios.create()

setupInterceptorsTo(farmbookAxios, metaEnv.farmbookAPI)
setupInterceptorsTo(axios, metaEnv.baseAPI)

export default function App() {

  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            cacheTime: 0,
            staleTime: 60000 * 60,
          }
        }
      })
  );

  return (
    <>
      <Provider store={store}>
        <SnackBarProviderConfig>
          <QueryClientProvider client={queryClient}>
              <ThemeProvider theme={mainTheme}>
                <CssBaseline>
                  <ScreenProvider>
                    {/* GetUserInfo is fetch data before render route */}
                    <GetUserInfo>
                      <Suspense fallback={<LoadingFullScreen />}>
                        <BrowserRouter basename={metaEnv.basepath}>
                          <AdminSessionExpiredDialog />
                          <RenderRoute />
                        </BrowserRouter>
                      </Suspense>
                    </GetUserInfo>
                  </ScreenProvider>
                </CssBaseline>
              </ThemeProvider>
            <ReactQueryDevtools initialIsOpen={metaEnv.isDev} />
          </QueryClientProvider>
        </SnackBarProviderConfig>
      </Provider>
      
      {/* Environment Badge - Only shows in non-production environments */}
      <EnvironmentBadge position="top-right" />
    </>
  );
}
